import React from "react";
import "./AirportRides.css"; // Ajoutez un fichier CSS pour des styles personnalisés

// Importer les images depuis /src/assets/images
import image1 from "../../assets/images/seamless-airport-rides-in-paris-1.jpg";
import image2 from "../../assets/images/seamless-airport-rides-in-paris-2.jpg";
import image3 from "../../assets/images/seamless-airport-rides-in-paris-3.jpg";

const AirportRides = () => {
  return (
    <section id="airport-rides" className="container-fluid py-5">
        <h2 className="mb-4 text-dark text-center">Seamless Airport Rides in Paris</h2>
      <div className="row align-items-center">
        {/* Section des images */}
        <div className="col-lg-6">
          <div className="row g-3">
            <div className="col-6">
              <img
                src={image1}
                alt="Airport Waiting Area"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-6">
              <img
                src={image2}
                alt="Airport Lounge"
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-12">
              <img
                src={image3}
                alt="Child at Airport"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>

        {/* Section du texte */}
        <div className="col-lg-6 text-center text-lg-start">
          <h2 className="mb-4 text-dark ">Effortless Transit</h2>
          <p className="text-muted">
            Experience smooth and punctual airport transfers in Paris with RS Transports – ensuring a stress-free journey every time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AirportRides;
